import { TextField, MenuItem } from '@mui/material';
import { Controller, get } from 'react-hook-form';

const HookFormTextField = ({
  name,
  label,
  helperText,
  formMethods,
  onChange: onChangeHandler = () => {},
  deps = [],
  options,
  children,
  select = false,
  ...props
}) => {
  const {
    control,
    trigger,
    formState: { errors },
  } = formMethods;
  // The name can be a path into a nested value, like the field it controls.
  const error = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextField
          id={name}
          name={name}
          label={label || name}
          helperText={error?.message || helperText || ''}
          error={Boolean(error)}
          value={value || (value === 0 ? 0 : '')}
          onChange={event => {
            deps.forEach(dep => trigger(dep));
            onChange(event);
            onChangeHandler(event);
          }}
          select={select}
          {...props}>
          {select && options
            ? options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            : children}
        </TextField>
      )}
    />
  );
};

export default HookFormTextField;
